// extracted by mini-css-extract-plugin
export default {"chat":"_41xJX","messages":"A3LaP","controls":"p6-0B","backToBottom":"uuyAd"};